// slotConfig.js — single source of truth for custom-league roster shapes (web).
// Mirror of mobile/src/lib/slotConfig.js: accepts a league doc (nested
// settings), a bare settings object, or a doc with top-level slot_config.
// An EXPLICIT 0 cap means "category disabled" — never "default 3".

export const DEFAULT_SLOT_TOTAL = 18;
export const DEFAULT_PER_CATEGORY_CAP = 3;

export const CATEGORY_ORDER = ['country_leader', 'ceo', 'actor', 'athlete', 'musician', 'influencer'];

const VALID_CATEGORIES = new Set(CATEGORY_ORDER);

export function readSlotConfig(leagueLike) {
  const cfg = leagueLike?.settings?.slot_config || leagueLike?.slot_config || {};
  const clean = {};
  for (const [k, v] of Object.entries(cfg)) {
    // Ignore stale keys from legacy configs (e.g. `fictional`) so the
    // denominator can never regress to 21.
    if (VALID_CATEGORIES.has(k)) clean[k] = Math.max(0, Number(v) || 0);
  }
  return clean;
}

export function getSlotLimits(leagueLike) {
  const config = readSlotConfig(leagueLike);
  const hasCustom = Object.keys(config).length > 0;
  const customTotal = Object.values(config).reduce((a, b) => a + b, 0);
  return {
    hasCustom,
    config,
    total: hasCustom && customTotal > 0 ? customTotal : DEFAULT_SLOT_TOTAL,
    perCategory: (cat) => (hasCustom ? (config[cat] || 0) : DEFAULT_PER_CATEGORY_CAP),
    activeCategories: hasCustom
      ? CATEGORY_ORDER.filter((c) => (config[c] || 0) > 0)
      : CATEGORY_ORDER.slice(),
  };
}
